var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showMain)?[_c('Main',{attrs:{"baseUrl":_vm.baseUrl}})]:[_c('Album',{attrs:{"baseUrl":_vm.baseUrl,"albumUrl":_vm.albumUrl}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }